import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class ParameterGroupFormModel extends FormModel {

    @IsRequired()
    name: string

    /** Parametros selecionados no picker para inclusao (criacao ou adicao). */
    @IsOptional()
    fieldCodesToAdd?: number[]

    constructor(initialData?: Partial<ParameterGroupFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
